import { ADMIN_GET_USERS } from "../actions/types";


const initialState = {
    users:[],
};

export default function adminGetAllUser(state = initialState, action) {
    const {type, payload} = action;
    
    switch (type){
        case ADMIN_GET_USERS:
            if (typeof payload === "object" && payload?.usersWithExtraDetails?.length > 0) {
                return {
                    ...state , loading: true,
                    users: [...action.payload.usersWithExtraDetails],
                };
            } else {
                console.error("Payload is not an array or is empty");
                return state;
            }
        default:
            return state;
    }

}